var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control mobile dsf_teas_student_wubie" },
    [
      _vm.list.length > 0
        ? _c(
            "van-pull-refresh",
            {
              on: { refresh: _vm.onRefresh },
              model: {
                value: _vm.refreshing,
                callback: function ($$v) {
                  _vm.refreshing = $$v
                },
                expression: "refreshing",
              },
            },
            [
              _c(
                "van-list",
                {
                  attrs: {
                    finished: _vm.finished,
                    "finished-text": "没有更多了",
                  },
                  on: { load: _vm.getList },
                  model: {
                    value: _vm.loading,
                    callback: function ($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "list" },
                    _vm._l(_vm.list, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "list-item" },
                        [
                          _c("div", { staticClass: "date" }, [
                            _c("div", { staticClass: "datetitle" }, [
                              _vm._v(
                                " " +
                                  _vm._s(item.dateTime) +
                                  " " +
                                  _vm._s(item.weekStr) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "atten-content" },
                            _vm._l(
                              item.studentNoons,
                              function (stuItem, stuindex) {
                                return _c(
                                  "div",
                                  {
                                    key: stuindex,
                                    staticClass: "atten-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickItem(stuItem)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "time" }, [
                                      _c("div", { staticClass: "label" }, [
                                        _vm._v(_vm._s(stuItem.noonText)),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "right" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "value",
                                              class: {
                                                "text-green":
                                                  stuItem.resultValue == "1" ||
                                                  stuItem.resultValue == "5",
                                                "text-blue":
                                                  "678".indexOf(
                                                    stuItem.resultValue
                                                  ) !== -1,
                                                "text-red":
                                                  "156789".indexOf(
                                                    stuItem.resultValue
                                                  ) === -1,
                                                "text-grey":
                                                  stuItem.resultValue == "9",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(stuItem.resultText) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("dsf-icon", {
                                            staticClass:
                                              "right-icon icon-weibiaoti34",
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          )
        : _c("van-empty", { attrs: { description: "暂无数据" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }